import Vue from 'vue'
import moment from 'moment'
import { GET_CHILD, GET_PAYER_INFO } from '@/requests/parent'
import { FORMAT } from '@/config'

const state = {
  childId: null,
  loaded: false,
  payer: {
    balance: 0
  },
  data: {
    cards: [],
    parent: {
      is_oferta_accepted: false
    }
  }
}

const mutations = {
  setAsChildLoaded(state) {
    state.loaded = true
  },
  setChildId(state, childId) {
    state.childId = childId
  },
  setParentPayer(state, payer) {
    state.payer = payer
  },
  setChildData(state, data) {
    state.data = {
      ...data,
      parent: {
        ...data.parent,
        first_tariff_activated_at: data.parent.first_tariff_activated_at ? 
          moment(data.parent.first_tariff_activated_at).format(FORMAT.dateTimeShort) :
          null
      }
    }
  }
}

const actions = {
  GET_CHILD_DATA: async ({ commit, state }) => {
    try {
      const { data } = await GET_CHILD({ childId: state.childId })
      commit('setChildData', data)
      return data
    } catch (error) {
      Vue.notify({
        type: 'error',
        text: 'Не удалось загрузить информацию о ребенке'
      })
      throw( error )
    } finally {
      commit('setAsChildLoaded', false)
    }
  },
  GET_PAYER_INFO: async ({ commit, state }) => {
    try {
      const { data } = await GET_PAYER_INFO({ childId: state.childId })
      commit('setParentPayer', data)
    } catch (error) {
      Vue.notify({
        type: 'error',
        text: 'Не удалось загрузить информацию о ребенке'
      })
      throw( error )
    }
  }
}

export default {
  state,
  actions,
  mutations
}
